module.exports = "/assets/data/8963e4f1dfccc6eb27562a06b4abb17a-NN4.data.json";